<span class="user-roles" (click)="onClick()">{{ userRoles.join(', ') }}</span>
